import React from "react";

const paragraphs = [
  "[Placeholder — the origin story. Replace this with how the idea began. For example: the moment you and Nadi noticed how training attendance was still tracked on paper, how records went missing, and how compliance audits became a scramble. Describe the problem you lived through that made this worth solving.]",
  "[Placeholder — the insight. What did you realise that others hadn't? For example: that attendance isn't just a logistics task — it's a question of trust and proof. That the same simple act of \"checking in\" could scale from a training room to a conference hall to an event gate.]",
  "[Placeholder — the name. You may want to share the meaning here: Verisaya = truth, recorded in time. \"Veri\" for verification and trust; \"Saya\" echoing Samaya — time, order, presence.]",
  "[Placeholder — the mission today. Where you are now and where you're going: starting with the cleanest, most reliable training-attendance experience possible, then expanding into events, ticketing, and access control.]",
];

export default function OurStory() {
  return (
    <div style={s.page}>
      <p style={s.label}>OUR STORY</p>
      <h1 style={s.heading}>
        How <strong>Verisaya</strong> came to be.
      </h1>
      <p style={s.sub}>
        From a simple frustration with paper registers to a platform built on truth, time,
        and verified presence.
      </p>
      <div style={s.divider} />
      {paragraphs.map((text, i) => (
        <div key={i} style={s.block}>
          <div style={s.bar} />
          <p style={s.para}>{text}</p>
        </div>
      ))}
      <p style={s.closing}>
        <strong>Verisaya is not just attendance. It is verified presence, at scale.</strong>
      </p>
    </div>
  );
}

const s = {
  page: {
    background: "#0d1526",
    minHeight: "100vh",
    padding: "60px 10%",
    color: "#c8d6e5",
    fontFamily: "'Segoe UI', sans-serif",
  },
  label: {
    fontSize: 12,
    letterSpacing: 2,
    color: "#998046",
    textTransform: "uppercase",
    margin: "0 0 14px",
  },
  heading: {
    fontSize: 42,
    fontWeight: 300,
    color: "#e8f0fa",
    margin: "0 0 18px",
    lineHeight: 1.2,
  },
  sub: {
    fontSize: 14,
    color: "#8790a3",
    margin: "0 0 28px",
    maxWidth: 480,
    lineHeight: 1.6,
  },
  divider: {
    marginBottom: 28,
  },
  block: {
    display: "flex",
    gap: 16,
    marginBottom: 22,

  },
  bar: {
    width: 3,
    minHeight: "100%",
    background: "#998046",
    borderRadius: 2,
    flexShrink: 0,
  },
  para: {
    fontSize: 13,
    color: "#8790a3",
    fontStyle: "italic",
    lineHeight: 1.75,
    margin: 0,
  },
  closing: {
    fontSize: 20,
    color: "#c8d6e5",
    marginTop: 32,
  },
};
